module.exports = __webpack_public_path__ + "static/media/raven.1603b308.png";